import * as React from 'react'
import { Avatar, Row } from 'antd'
import { useIntl } from 'react-intl'
import styles from './CourierDetails.module.scss'
import { DeliveryCourierData, DeliveryStatus } from '../../store/DeliveryTracking/types'
import * as AnalyticsManager from '../../lib/analytics/analytics'

interface CourierDetailsProps {
  courier: DeliveryCourierData
  deliveryStatus: DeliveryStatus
  color: string
}

const CourierDetails = (props: CourierDetailsProps) => {
  const style: CSSStyleDeclaration = document.documentElement.style
  const { formatMessage } = useIntl()

  const didTapCallCourier = () => {
    AnalyticsManager.sendEvent(AnalyticsManager.Event.CallCourier)
  }

  const { courier: { name, picture, phone }, deliveryStatus, color } = props
  const translate = (id: string, values: any = {}) => formatMessage({ id }, values)
  const show = [
    DeliveryStatus.InPreparation,
    DeliveryStatus.OnTheWay,
    DeliveryStatus.Arriving,
  ].includes(deliveryStatus)
  style.setProperty('--call-button-color', color)

  return (
    show ? (
      <Row className={styles.container}>
        {(picture || name) && (
          <div>
            <Avatar
              className={styles.courierPhoto}
              size={48}
              src={picture}
              icon="user" />
          </div>
        )
        }
        <div>
          {name && <div className={styles.courierName}>{ name }</div>}
          {phone && (
            <div className={styles.callButton}>
              <a href={`tel://${phone}`} onClick={didTapCallCourier}>
                { translate('call_courier') }
              </a>
            </div>
          )}
        </div>
      </Row>
    ) : null
  )
}

export default CourierDetails
